var _path;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgTrash = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91,346H88a3,3,0,0,0-3-3H83a3,3,0,0,0-3,3H77a1,1,0,0,0,0,2h1v8a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3v-8h1a1,1,0,0,0,0-2Zm-8-1h2a1,1,0,0,1,1,1H82A1,1,0,0,1,83,345Zm5,11a1,1,0,0,1-1,1H81a1,1,0,0,1-1-1v-8h8Zm-3.5-6v5a.5.5,0,0,1-1,0v-5a.5.5,0,0,1,1,0Zm2,1v3a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Zm-4,0v3a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Z",
    transform: "translate(-72 -339)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.23c3b015.svg";
export { ForwardRef as ReactComponent };